import AnimatedMarketItemCard from '../components/AnimatedMarketItemCard';
import { MARKETITEMS } from '../app/shared/MarketStore';
import { Row, Col } from 'reactstrap';

const Market = () => {
    return(
        <Row id='marketBG'>
            <h1>Mercado</h1>
            <h1 style={{ margin: '0rem', color: '#000', background:'yellow'}}>Under Construction</h1>
            <div id='marketDiv'>
                <h2>Bienvenidos a Nuestra Tiendita</h2>
                <p style={{margin: '2rem 15rem'}}>
                    Irure cillum dolor irure minim. Do aliqua 
                    consectetur laboris est et ex nisi quis sunt 
                    commodo cillum. Occaecat esse esse ut occaecat 
                    aute ullamco nulla ea non laboris cillum ea. Eu 
                    mollit ullamco adipisicing commodo quis pariatur 
                    laborum eu laborum. Eiusmod aliquip dolore nisi 
                    elit nisi aliquip amet aliqua esse adipisicing. 
                    Duis id nulla reprehenderit ullamco amet eu veniam 
                    ex voluptate quis ad duis elit enim.Irure cillum dolor 
                    irure minim. Do aliqua et ex nisi quis sunt
                    consectetur laboris est et ex nisi quis sunt 
                    commodo cillum. Occaecat esse esse ut occaecat 
                    aute ullamco nulla ea non laboris cillum ea. Eu 
                    mollit ullamco adipisicing commodo quis pariatur 
                    laborum eu laborum. Eiusmod aliquip dolore nisi 
                    elit nisi aliquip amet aliqua esse adipisicing. 
                    Duis id nulla reprehenderit ullamco amet eu veniam 
                    ex voluptate quis ad duis elit enim.
                </p>
            </div>
            <div id='marketStoreBackDrop'>
                <Row style={{ display:'flex', justifyContent:'center' }}>
                        {
                            MARKETITEMS.map((item, idx) => {
                                return (
                                    <Col sm='12' md='6' lg='4' xl='3' className='my-5 mx-5'>
                                        <AnimatedMarketItemCard item={item} idx={idx} />
                                    </Col>
                                );
                            })
                        }
                </Row>
            </div>
        </Row>
    );
};

export default Market;